export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-noticebar/index.js